// 对公打款页 - 订单明细表头
export let toPublicPayment_orderHeaderList = [
    {
        prop: "come_from_desc",
        label: "渠道",
        width: 80,
    },
    {
        prop: "order_no",
        label: "订单编号",
    },
    {
        prop: "title",
        label: "课程名称",
    },
    {
        prop: "pay_amount",
        label: "支付金额",
    },
    {
        prop: "pay_time",
        label: "支付时间",
    },
    {
        prop: "income",
        label: "实际收益",
    },
    {
        prop: "is_settle",
        label: "收益状态",
    },
    {
        prop: "merchant_id",
        label: "结算商户",
    },
]

// 对公打款页 - 课程明细表头
export let toPublicPayment_classHeaderList = [
    {
        prop: "come_from_name",
        label: "渠道",
        width: 80,
    },
    {
        prop: "product_title",
        label: "课程名称",
    },
    {
        prop: "gmv",
        label: "成交gmv",
    },
    {
        prop: "sales",
        label: "成交单数",
    },
    {
        prop: "income",
        label: "总收益",
    },
    {
        prop: "sales_refund",
        label: "退款单数",
    },
    {
        prop: "gmv_refund",
        label: "退款金额",
    },
    {
        prop: "refund_rate",
        label: "退款率",
    },
]

// 对公打款页 - 汇总table表头
export let toPublicPayment_summaryHeaderList = [
    {
        prop: "come_from_desc",
        label: "渠道",
        width: 50
    },
    {
        prop: "pay_gmv",
        label: "成交gmv",
        width: 100,
    },
    {
        prop: "pay_count",
        label: "成交单数",
    },
    {
        prop: "settle_gmv",
        label: "结算gmv",
        width: 100,
    },
    {
        prop: "settle_count",
        label: "结算单数",
        tip: "抖音官方已结算的订单数"
    },
    {
        prop: "dy_merchant_income",
        label: "抖音商户收益",
        width: 118
    },
    {
        prop: "db_merchant_income",
        label: "豆包账户收益",
        width: 108
    },
    {
        prop: "total_income",
        label: "总收益",
        width: 100,
        tip: "分到抖音商户和豆包账户的总收益"
    },
    {
        prop: "db_rate",
        label: "平台抽点（当前）",
        width: 80
    },
    {
        prop: "payment",
        label: "应收账款",
        width: 100,
        tip: "豆包平台应该结算给讲师的收益"
    }
]

// 对公打款申请记录页 - 表头
export const applyPaymentHistory_headerList = [
    {
        prop: "id",
        label: "ID",
        width: 104
    },
    {
        prop: "payment_amount",
        label: "申请打款总金额",
        width: 130
    },
    {
        prop: "account_name",
        label: "账户名称",
        width: 100
    },
    {
        prop: "account",
        label: "账号",
        width: 100
    },
    {
        prop: "bank",
        label: "开户银行",
        width: 100
    },
    {
        prop: "status_desc",
        label: "状态",
        width: 100
    },
    {
        prop: "my_pingzheng",
        label: "打款凭证",
        width: 100,
    },
    {
        prop: "refuse_reason",
        label: "拒绝原因",
        width: 100,
        bindObj: {
            'show-overflow-tooltip': true
        }
    },
    {
        prop: "created_time",
        label: "申请时间",
        width: 100
    }
]

// 提现页-提现账户状态相关
export const accountList_statusColorObj = {
    1: {
        title: '审核中',
        color: '#FFA555',
        canClk: false // 允许点击
    },
    2: {
        title: '审核通过',
        color: '#2DC695',
        canClk: true
    },
    3: {
        title: '审核失败',
        color: '#EA4B4B',
        showFail: true, // 展示失败原因
        canClk: false
    },
    5: {
        title: '签约中',
        color: '#FFA555',
        canClk: false
    },
    4: {
        title: '点击验证',
        color: '#FFA555',
        canClk: true,
        needValidate: true // 需要校验
    },
}

// 提现页-提现账户详情-对应商户状态
export const accountList_merchantStatusObj = {
    1: {
        title: '审核中',
    },
    2: {
        title: '审核通过',
    },
    3: {
        title: '审核失败',
        showFail: true // 展示原因
    },
    5: {
        title: '签约中',
    },
    4: {
        title: '点击验证',
        needValidate: true // 需要校验
    },
}